/**
 * For manage sessionstorage
 * @author Daniel Santos <daniel.santos@gradiweb.com>
 */
class ManageLocalStorage {
  /**
   * Add data.
   * @param {string} key - Key for search data
   * @param {object/string} data - data
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  addData(key, data) {
    const dataSave = JSON.stringify(data);
    window.localStorage.setItem(key, dataSave);
    return true;
  }

  /**
   * Get data.
   * @param {string} key - Key for search data
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  getData(key) {
    const response = JSON.parse(window.localStorage.getItem(key));
    return response;
  }

  /**
   * Remove data.
   * @param {string} key - Key for search data
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  removeData(key) {
    const response = window.localStorage.removeItem(key);
    return response;
  }
}

export { ManageLocalStorage };
